import React from 'react'
import App from '../containers/App'
import { isLoggedIn, isBrowser } from '../utils/localStorage'

import withPermissions from '../containers/withPermissions'

const decorate = withPermissions

const PrivateRoute = ({
  component: Component,
  location,
  permissions,
  hasPermissions,
  ...rest
}) => {
  return (
    <App.Consumer>
      {({ permissions, logout }) => {
        if (!isLoggedIn()) {
          if (isBrowser) logout()
          return null
        }
        if (permissions && !hasPermissions(permissions)) {
          return <LacksPermissions />
        }

        return <Component location={location} {...rest} />
      }}
    </App.Consumer>
  )
}

const LacksPermissions = () => <p>Brak Uprawnień</p>

export default decorate(PrivateRoute)
